{
  "tabs": {
    "chat": "চেট",
    "reminders": "স্মৰণীয়",
    "calendar": "পঞ্জিকা",
    "settings": "ছেটিংছ"
  },
  "common": {
    "cancel": "বাতিল",
    "save": "সংৰক্ষণ",
    "confirm": "নিশ্চিত কৰক",
    "delete": "মচি পেলাওক",
    "back": "পিছলৈ",
    "close": "বন্ধ কৰক",
    "edit": "সম্পাদনা",
    "search": "সন্ধান",
    "all": "সকলো",
    "loading": "লোড হৈছে...",
    "error": "কিবা এটা ভুল হৈছে",
    "notFound": "নাপোৱা গ’ল",
    "tryAgain": "অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক",
    "retry": "পুনৰ চেষ্টা কৰক",
    "undo": "পূৰ্বাবস্থালৈ উভতি যাওক",
    "pullToRefresh": "ৰিফ্ৰেশ কৰিবলৈ টানি আনি",
    "justNow": "এতিয়াই"
  },
  "auth": {
    "welcome": "FishMemory ত আপোনাক স্বাগতম",
    "tagline": "আপোনাৰ WhatsApp স্মৰণীয় সহায়ক, এতিয়া আপোনাৰ পকেটত।",
    "subtitle": "আপোনাৰ WhatsApp স্মৰণীয় সহায়ক, এতিয়া আপোনাৰ পকেটত।",
    "phoneLabel": "আপোনাৰ WhatsApp নম্বৰ",
    "phoneHint": "আমিয়ে WhatsApp যোগে যাচাইকৰণ কোড পঠিয়াম",
    "invalidPhone": "অনুগ্ৰহ কৰি সঠিক ফোন নম্বৰ দিয়ক",
    "continue": "অগ্ৰসর হওক",
    "enterPhone": "আপোনাৰ WhatsApp নম্বৰ লিখক",
    "phonePlaceholder": "ফোন নম্বৰ",
    "sendCode": "কোড পঠিয়াওক",
    "verifyTitle": "আপোনাৰ নম্বৰ যাচাই কৰক",
    "otpSentTo": "৬-আংকীয় কোডটো {{phone}} ত WhatsApp যোগে পঠিয়োৱা হৈছে",
    "enterFullCode": "অনুগ্ৰহ কৰি সকলো ৬ আংক লিখক",
    "invalidOtp": "অবৈধ কোড। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    "otpFailed": "কোড পঠিয়াব পৰা নগ’ল। পুনৰ চেষ্টা কৰক।",
    "otpResent": "কোড পুনৰ পঠিয়োৱা হৈছে",
    "resendIn": "{{seconds}} ছেকেণ্ডত পুনৰ পঠিয়াওক",
    "resendCode": "কোড পুনৰ পঠিয়াওক",
    "enterOtp": "আপোনাৰ WhatsApp ত পঠিওৱা কোড লিখক",
    "verify": "যাচাই কৰক",
    "resend": "কোড পুনৰ পঠিয়াওক",
    "wrongNumber": "ভুল নম্বৰ?",
    "backToPhone": "ফোনলৈ উভতি যাওক",
    "editPhone": "ফোন নম্বৰ সম্পাদনা কৰক",
    "error": "ভুল",
    "setupTitle": "চল, সাজু হওঁ",
    "setupSubtitle": "আপুনি পাছত ছেটিংছত সলনি কৰিব পাৰে",
    "namePlaceholder": "আপোনাৰ নাম",
    "letsGo": "সাজু সম্পূৰ্ণ কৰক",
    "skipForNow": "এতিয়াৰ বাবে এৰাই যাওক"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "এটা বাৰ্তা টাইপ কৰক...",
    "inputPlaceholder": "এটা বাৰ্তা টাইপ কৰক...",
    "typing": "FishMemory টাইপ কৰি আছে...",
    "online": "অনলাইন",
    "connecting": "সংযোগ হৈছে...",
    "reconnecting": "পুনৰ সংযোগ হৈছে...",
    "offline": "অফলাইন",
    "empty": "এটা বাৰ্তা আৰম্ভ কৰক",
    "emptyHint": "স্মৰণীয় সৃষ্টি কৰক, আপোনাৰ সময়সূচী চাওক, বা সহায় বিচাৰক।",
    "emptyAction": "এটা নমুনা স্মৰণীয় পঠিয়াওক",
    "actions": "চেট কাৰ্য",
    "keep": "বার্তা ৰাখক",
    "clearTitle": "চেট মচি পেলাওক",
    "clearConfirm": "এই ডিভাইচৰ পৰা সকলো বাৰ্তা মচি পেলাব? এইটো উলটাই নোপোৱা।",
    "clear": "চেট মচি পেলাওক",
    "optionSelected": "নিৰ্বাচিত: {{label}}",
    "sendingSelection": "পঠিয়াইছে...",
    "connectionLost": "পুনৰ সংযোগ হৈছে..."
  },
  "reminders": {
    "title": "মোৰ স্মৰণীয়",
    "active": "সক্রিয়",
    "today": "আজিৰ",
    "thisWeek": "এই সপ্তাহ",
    "history": "ইতিহাস",
    "items": "আইটেম",
    "emptyTitle": "এতিয়ালৈকে কোনো স্মৰণীয় নাই",
    "emptySubtitle": "চেটৰ পৰা এটা সৃষ্টি কৰক আৰু ইয়াত দেখুওৱা হ'ব।",
    "emptyAction": "চেট খোলক",
    "filterActive": "সক্রিয়",
    "filterToday": "আজিৰ",
    "filterWeek": "এই সপ্তাহ",
    "filterHistory": "ইতিহাস",
    "emptyState": "এতিয়ালৈকে কোনো স্মৰণীয় নাই। চেট আৰম্ভ কৰক!",
    "swipeDone": "সম্পূৰ্ণ",
    "swipeSnooze": "স্নুজ",
    "swipeDelete": "মচি পেলাওক",
    "search": "স্মৰণীয় সন্ধান কৰক...",
    "upcoming": "আসন্ন",
    "completed": "সম্পূৰ্ণ",
    "overdue": "অতীত",
    "tomorrow": "কাইলৈ",
    "synced": "সমন্বয়িত {{value}}",
    "swipeHint": "অধিক কাৰ্যৰ বাবে স্মৰণীয়টো ছুইপ কৰক",
    "noResults": "আপোনাৰ সন্ধানৰ সৈতে কোনো স্মৰণীয় মিল নাখায়",
    "noResultsHint": "বিভিন্ন শব্দ ব্যৱহাৰ কৰক বা সন্ধান মচি পেলাওক",
    "deleteAllFailed": "সকলো স্মৰণীয় মচি পেলাব পৰা নগ’ল"
  },
  "calendar": {
    "title": "পঞ্জিকা",
    "today": "আজিৰ",
    "tomorrow": "কাইলৈ",
    "completed": "সম্পূৰ্ণ",
    "noEvents": "কোনো কাৰ্যসূচী নাই",
    "noEventsSubtitle": "স্মৰণীয় আৰু পঞ্জিকা কাৰ্যসূচী চাবলৈ এটা তাৰিখ বাছক।",
    "googleEvent": "Google Calendar",
    "legendActive": "সক্রিয়",
    "legendRecurring": "পুনৰাবৃত্তি",
    "legendDone": "সম্পূৰ্ণ",
    "legendGoogle": "Google",
    "previousMonth": "অতীত মাহ",
    "nextMonth": "পৰৱৰ্তী মাহ",
    "previousYear": "অতীত বছৰ",
    "nextYear": "পৰৱৰ্তী বছৰ",
    "goToToday": "আজিৰ দিনলৈ যাওক",
    "all": "সকলো",
    "active": "সক্রিয়",
    "done": "সম্পূৰ্ণ",
    "paused": "বিৰতি"
  },
  "settings": {
    "title": "ছেটিংছ",
    "profile": "প্ৰফাইল",
    "name": "প্ৰদৰ্শন নাম",
    "enterName": "আপোনাৰ নাম লিখক",
    "language": "ভাষা",
    "uiLanguage": "এপৰ ভাষা",
    "uiLanguageHelp": "এই ডিভাইচত কেৱল এপ UI, পঞ্জিকা লেবেল আৰু বিন্যাস দিশ সলনি কৰে।",
    "serverLanguage": "চেট ভাষা",
    "serverLanguageHelp": "আপোনাৰ একাউণ্টৰ বাবে ছাৰ্ভাৰৰ উত্তৰ আৰু স্মৰণীয় বাৰ্তাৰ ভাষা সলনি কৰে।",
    "timezone": "সময় অঞ্চল",
    "currentTimezone": "বৰ্তমান সময় অঞ্চল",
    "timezoneHelp": "সকলো স্মৰণীয় সময় এই সময় অঞ্চল অনুসৰি দেখুওৱা হয়।",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "সময় অঞ্চল সংৰক্ষণ কৰক",
    "timezoneSaved": "সময় অঞ্চল আপডে'ট হৈছে",
    "detect": "পৰিচয় কৰক",
    "detectFailed": "সময় অঞ্চল পৰিচয় কৰিব পৰা নগ’ল",
    "autoDetect": "GPSৰ পৰা স্বয়ংক্ৰিয় পৰিচয়",
    "notifications": "বিজ্ঞপ্তি",
    "notificationsHelp": "পুনৰ স্মৰণীয়ৰ দ্বাৰা স্মৰণীয় দিয়া পিছত পুনৰ সতৰ্কবাণী নিয়ন্ত্ৰণ কৰা হয়। ডিভাইচ-স্তৰৰ বিজ্ঞপ্তি অনুমতি আপোনাৰ ফোন ছেটিংছত ব্যৱস্থাপিত হয়।",
    "pushEnabled": "পুশ বিজ্ঞপ্তি",
    "autoDoneOnFire": "ফায়াৰ হ'লে স্বয়ংক্ৰিয়ভাৱে সম্পূৰ্ণ চিহ্নিত কৰক",
    "autoDoneOnFireDesc": "বন্ধ থাকিলে, স্মৰণীয় সক্ৰিয় অৱস্থাত থাকে যেতিয়ালৈকে আপুনি সম্পূৰ্ণ বুলি চিহ্নিত নকৰে।",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "সংযুক্ত",
    "googleDisconnected": "সংযুক্ত নহয়",
    "googleConnectedHelp": "নতুন স্মৰণীয় স্বয়ংক্ৰিয়ভাৱে আপোনাৰ পঞ্জিকাত সমন্বয় কৰিব পাৰে।",
    "googleDisconnectedHelp": "Google Calendar সংযুক্ত কৰক যাতে স্মৰণীয় আৰু কাৰ্যসূচী মিল থাকে।",
    "googleConnectFailed": "Google Calendar সংযুক্ত কৰিব পৰা নগ’ল",
    "connected": "সংযুক্ত",
    "disconnected": "সংযুক্ত নহয়",
    "connect": "সংযুক্ত কৰক",
    "disconnect": "সংযোগ বিচ্ছিন্ন কৰক",
    "autoSync": "নতুন স্মৰণীয় স্বয়ংক্ৰিয় সমন্বয়",
    "autosync": "নতুন স্মৰণীয় স্বয়ংক্ৰিয় সমন্বয়",
    "subscription": "চাবস্ক্ৰিপচন",
    "trialUsed": "ট্ৰায়েল: {{used}}/{{total}} ব্যৱহৃত",
    "trialStatus": "ট্ৰায়েল উপলব্ধ",
    "activeStatus": "সক্রিয় চাবস্ক্ৰিপচন",
    "expiredStatus": "চাবস্ক্ৰিপচন মেয়াদ উত্তীর্ণ",
    "unsubscribedStatus": "চাবস্ক্ৰিপচন নাই",
    "about": "সম্পৰ্কে",
    "version": "সংস্কৰণ",
    "logout": "লগ আউট",
    "logoutTitle": "লগ আউট",
    "logoutConfirm": "আপুনি নিশ্চিতনে লগ আউট কৰিব?",
    "noName": "নাম নিৰ্ধাৰিত নহয়",
    "serverConnection": "ছাৰ্ভাৰ সংযোগ",
    "serverUrl": "ছাৰ্ভাৰ URL",
    "serverEdit": "সম্পাদনা",
    "saveReconnect": "সংৰক্ষণ আৰু পুনৰ সংযোগ",
    "resetDefault": "ডিফল্টত পুনৰায় স্থাপন কৰক",
    "invalidServerUrlTitle": "অবৈধ ছাৰ্ভাৰ URL",
    "invalidServerUrlMessage": "এক বৈধ http বা https ছাৰ্ভাৰ URL লিখক, যেনে https://example.com",
    "uiLanguageChangeFailed": "এপৰ ভাষা সলনি কৰিব পৰা নগ’ল। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    "serverLanguageChangeFailed": "চেট ভাষা সলনি কৰিব পৰা নগ’ল। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    "timezoneChangeFailed": "সময় অঞ্চল সলনি কৰিব পৰা নগ’ল। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    "autoSyncChangeFailed": "স্বয়ংক্ৰিয় সমন্বয় আপডে'ট কৰিব পৰা নগ’ল। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    "nameChangeFailed": "প্ৰদৰ্শন নাম আপডে'ট কৰিব পৰা নগ’ল। অনুগ্ৰহ কৰি পুনৰ চেষ্টা কৰক।",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "স্মৰণীয় বিৱৰণ",
    "editTime": "সময় সম্পাদনা কৰক",
    "rename": "নাম সলনি কৰক",
    "snooze": "স্নুজ",
    "snooze15": "১৫ মিনিট স্নুজ",
    "pause": "বিৰতি",
    "pauseReminder": "স্মৰণীয় বিৰতি কৰক",
    "resume": "পুনৰ আৰম্ভ কৰক",
    "resumeReminder": "স্মৰণীয় পুনৰ আৰম্ভ কৰক",
    "skip": "পৰৱৰ্তী এৰাই যাওক",
    "skipOccurrence": "এই ঘটনাটো এৰাই যাওক",
    "syncGoogle": "Google ত সমন্বয় কৰক",
    "delete": "মচি পেলাওক",
    "deleteTitle": "স্মৰণীয় মচি পেলাওক",
    "deleteConfirm": "এই স্মৰণীয় স্থায়ীভাৱে মচি পেলোৱা হ'ব।",
    "deleteRecurringTitle": "পুনৰাবৃত্তি স্মৰণীয় মচি পেলাওক",
    "deleteRecurringMessage": "আপুনি এই ঘটনাটো এৰাই যাব বিচাৰে নে সমগ্ৰ শৃংখলাটো মচি পেলাব?",
    "deleteThisOccurrence": "এই ঘটনাটো এৰাই যাওক",
    "deleteEntireSeries": "সমগ্ৰ শৃংখলাটো মচি পেলাওক",
    "done": "সম্পূৰ্ণ",
    "markDone": "সম্পূৰ্ণ বুলি চিহ্নিত কৰক",
    "undo": "পুনৰুদ্ধাৰ",
    "undoPrompt": "আৰু সক্ৰিয় কৰিব বিচাৰে? এতিয়াই পুনৰুদ্ধাৰ কৰক।",
    "recurring": "পুনৰাবৃত্তি",
    "nextRun": "পৰৱৰ্তী চলা",
    "oneTime": "এবাৰহে",
    "pending": "অপেক্ষমাণ",
    "sent": "পঠিওৱা হৈছে",
    "paused": "বিৰতি",
    "active": "সক্রিয়",
    "snoozed": "স্নুজ কৰা হৈছে",
    "localTime": "আপোনাৰ স্থানীয় সময়ত দেখুওৱা হৈছে",
    "recurrence": "পুনৰাবৃত্তি",
    "created": "সৃষ্টি কৰা হৈছে",
    "tags": "টেগ",
    "fireCount": "বাৰ ফায়াৰ হৈছে",
    "actions": "কাৰ্য",
    "none": "নাই",
    "snoozeFailed": "স্মৰণীয় স্নুজ কৰিব পৰা নগ’ল",
    "pauseFailed": "স্মৰণীয় বিৰতি কৰিব পৰা নগ’ল",
    "resumeFailed": "স্মৰণীয় পুনৰ আৰম্ভ কৰিব পৰা নগ’ল",
    "skipFailed": "স্মৰণীয় এৰাই যাব পৰা নগ’ল",
    "doneFailed": "স্মৰণীয় সম্পূৰ্ণ বুলি চিহ্নিত কৰিব পৰা নগ’ল",
    "undoFailed": "স্মৰণীয় অৱস্থা পুনৰুদ্ধাৰ কৰিব পৰা নগ’ল",
    "deleteFailed": "স্মৰণীয় মচি পেলাব পৰা নগ’ল",
    "rescheduleTitle": "পুনৰ সময় নিৰ্ধাৰণ কৰিব?",
    "rescheduleMsg": "এই স্মৰণীয় অতীত হৈছে। আপুনি পুনৰ সময় নিৰ্ধাৰণ কৰিব বিচাৰে নে?",
    "reschedule15": "১৫ মিনিটত",
    "reschedule60": "১ ঘণ্টাত",
    "keepOverdue": "যি আছে সেয়া ৰাখক"
  },
  "onboarding": {
    "slide1Title": "FishMemory ত আপোনাক স্বাগতম",
    "slide1Sub": "আপোনাৰ ব্যক্তিগত স্মৰণীয় সহায়ক — WhatsApp দ্বাৰা চালিত আৰু আপোনাৰ পকেটৰ বাবে নিৰ্মিত।",
    "slide2Title": "স্বাভাৱিকভাৱে চেট কৰক",
    "slide2Sub": "আপোনাৰ চিন্তাধাৰাৰ দৰে স্মৰণীয় টাইপ কৰক: \"মোক কাইলৈ ৩ বজাৰ মাকক ফোন কৰিবলৈ স্মৰণীয় কৰক\" — বাকী আমি কৰিম।",
    "slide3Title": "কেতিয়াও কোনো বস্তু নাপাহৰিব",
    "slide3Sub": "সময়মতে বিজ্ঞপ্তি পাব, টেগৰ সৈতে সংগঠিত থাকক, আৰু সকলো গুৰুত্বপূর্ণ বিষয়ত সজাগ থাকক।",
    "getStarted": "আৰম্ভ কৰক",
    "next": "পৰৱর্তী",
    "firstReminderTitle": "আপোনাৰ প্ৰথম স্মৰণীয় সৃষ্টি কৰক!",
    "firstReminderHint": "এইদৰে টাইপ কৰি চাওক:",
    "firstReminderExample": "মোক কাইলৈ ৯ বজাত পানী খাবলৈ স্মৰণীয় কৰক",
    "gotIt": "বুজিলোঁ!",
    "notifRationaleTitle": "সময়ত থাকক",
    "notifRationaleBody": "FishMemory-এ আপোনাক সময়মতে স্মৰণীয় দিবৰ বাবে বিজ্ঞপ্তিৰ প্ৰয়োজন। আপুনি সৃষ্টি কৰা স্মৰণীয়ৰ বাবে কেৱল সতৰ্কবাণী পাব।",
    "notifRationaleAllow": "বিজ্ঞপ্তি সক্ষম কৰক",
    "notifRationaleLater": "পাছত কৰিব পাৰি",
    "swipeHint": "দ্রুত কাৰ্যৰ বাবে সোঁফালে ছুইপ কৰক →",
    "calendarDragHint": "বঢ়াবলৈ টানি আনি ↕"
  }
}
